module.exports = __webpack_public_path__ + "static/img/wealth_level_90.8b122a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_90.png
// module id = +A5o
// module chunks = 0